import React from "react"
import Router from "../routes/index"
import "./styles/styles.css"
import Layout from "../pages/Layout"
import { HashRouter } from "react-router-dom"

const App = () => {
  return (
    <HashRouter>
      <Layout>
        <Router />
      </Layout>
    </HashRouter>
  )
}

export default App
